import UtilityService, { serialize } from '@/services/UtilityService';
import ApiFactory from '@/factories/ApiFactory';

const get = (filters) => {
	return new Promise((resolve, reject) => {
		const query = serialize(filters);
		ApiFactory.get(`posweb/v1/dashboard?${query}`).then(
			({ data }) => {
				resolve(data.data);
			},
			(error) => reject(error)
		);
	});
};

const customSortItems = (items) => {
	const mappedOrder = {
		OrdersNo: 1,
		Rejected: 2,
		'GMV Order': 3,
		Transport: 4,
		'AVG Order': 5,
	};
	return UtilityService.sortByProp(
		items.map((item) => ({
			...item,
			sortIndex: mappedOrder[item.type],
		})),
		'sortIndex'
	);
};

const statistics = (filters) => {
	return new Promise((resolve, reject) => {
		const query = serialize(filters);
		ApiFactory.get(`posweb/v1/dashboard/statistics?${query}`).then(
			({ data }) => {
				let { statistics, chart } = data.data;
				statistics = customSortItems(statistics);
				resolve({ statistics, chart });
			},
			(error) => reject(error)
		);
	});
};

const getReviews = (id, filters) => {
	return new Promise((resolve, reject) => {
		const query = serialize(filters);
		ApiFactory.get(`posweb/v1/businesses/${id}/reviews?${query}`).then(
			({ data }) => {
				resolve(data.data);
			},
			(error) => reject(error)
		);
	});
};

const getReviewData = (restaurantId, reviewId, count) => {
	return new Promise((resolve, reject) => {
		ApiFactory.get(`posweb/v1/businesses/${restaurantId}/reviews/${reviewId}?${serialize(count)}`).then(
			({ data }) => {
				resolve(data.data[0]);
			},
			(error) => reject(error)
		);
	});
};

export default {
	get,
	statistics,
	getReviews,
	getReviewData,
};
